import { Loader2 } from "lucide-react";
import { Button } from "@/frontend/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/frontend/components/ui/dialog";
import { LEAVE_ERROR } from "@/frontend/constants/consent";

type ExitSetupDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Confirms the exit. It ends a patient session and goes back to the application, or it stops setup here. */
  onLeave: () => void;
  /** True while the exit is in progress. */
  isLeaving?: boolean;
  /** True when the last exit attempt failed. It shows the retry line. */
  hasError?: boolean;
};

/**
 * The confirmation dialog for the close control on the consent page. 
 */
export function ExitSetupDialog({
  open,
  onOpenChange,
  onLeave,
  isLeaving = false,
  hasError = false,
}: ExitSetupDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent showCloseButton={false} className="sm:max-w-sm">
        <DialogHeader>
          <DialogTitle>Exit setup?</DialogTitle>
          <DialogDescription className="text-body">
            <span className="font-semibold text-foreground">Nothing has been shared yet.</span> If
            you leave now, nothing gets connected.
          </DialogDescription>
        </DialogHeader>
        {hasError ? (
          <p role="alert" className="text-caption text-destructive">
            {LEAVE_ERROR}
          </p>
        ) : null}
        {/* DialogFooter stacks bottom-up on phones and left-to-right on desktop, so
            this order puts "Leave setup" above the safe action on a phone and to
            the right of it on a wide screen. */}
        <DialogFooter>
          <Button
            variant="outline"
            className="h-11 w-full text-body sm:w-auto"
            onClick={() => onOpenChange(false)}
          >
            Continue setup
          </Button>
          <Button
            variant="destructive"
            className="h-11 w-full text-body sm:w-auto"
            onClick={onLeave}
            disabled={isLeaving}
          >
            {isLeaving ? <Loader2 className="size-4 animate-spin" /> : null}
            Leave setup
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}

